export default "__VITE_ASSET__BXU_ISze__"